import { type StructuredReportsAndStudiesType } from '@/features/reportCards';

import { type UnifiedItem } from '../config';

type UnifiedItemsSource = {
  reports: StructuredReportsAndStudiesType[];
  rawMeshViewerItems?: UnifiedItem[];
};

/**
 * Merges report cards and raw mesh viewer cards into one list ordered by
 * date, newest first. Used for both the visible and the hidden sections of
 * the patient page so they always share the same ordering rules.
 */
export const getUnifiedItems = ({
  reports,
  rawMeshViewerItems = [],
}: UnifiedItemsSource): UnifiedItem[] =>
  [
    ...reports.map<UnifiedItem>((report) => ({
      type: 'report',
      data: report,
      date: report.date ?? 0,
    })),
    ...rawMeshViewerItems,
  ].sort((a, b) => b.date - a.date);

/** Distributes items into two columns, alternating left/right in order. */
export const splitIntoColumns = <T>(items: T[]): [T[], T[]] => [
  items.filter((_, index) => index % 2 === 0),
  items.filter((_, index) => index % 2 === 1),
];
